<template>
    <form :action="route('gamification.direct_currency_points.store')" @submit.prevent="submit">
        <div class="mt-1">
            <FormLabel :value="$tc('messages.experience_points', 2)" for="points" />
            <FormInput
                id="points"
                v-model.number="form.points"
                name="points"
                type="number"
                min="1"
                class="mt-1 w-full"
            />
            <FormError :value="form.errors.points" class="mt-2" />
        </div>

        <div class="mt-1">
            <FormLabel :value="$tc('messages.coins_amount', 2)" for="coins_points" />
            <FormInput
                id="coins_points"
                v-model.number="form.coins_points"
                name="coins_points"
                type="number"
                class="mt-1 w-full"
            />
            <FormError :value="form.errors.coins_points" class="mt-2" />
        </div>

        <div class="mt-1">
            <FormLabel :value="$tc('messages.health_amount', 2)" for="health_points" />
            <FormInput
                id="health_points"
                v-model.number="form.health_points"
                name="health_points"
                type="number"
                class="mt-1 w-full"
            />
            <FormError :value="form.errors.health_points" class="mt-2" />
        </div>

        <div class="mt-1">
            <FormLabel :value="$tc('messages.energy_amount', 2)" for="energy_points" />
            <FormInput
                id="energy_points"
                v-model.number="form.energy_points"
                name="energy_points"
                type="number"
                class="mt-1 w-full"
            />
            <FormError :value="form.errors.energy_points" class="mt-2" />
        </div>

        <div class="mt-1">
            <FormLabel :value="$t('messages.comment')" for="comment" />
            <FormInput
                id="comment"
                v-model.trim="form.comment"
                name="comment"
                type="text"
                max="120"
                class="mt-1 w-full"
            />
            <FormError :value="form.errors.comment" class="mt-2" />
        </div>

        <div class="flex justify-end mt-5">
            <SubmitFormButton :button-text="$t('messages.assign_points')" :processing="form.processing" />
        </div>
    </form>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '../../Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    emits: ['close'],
    name: 'GiveDirectCurrencyPointsForm',

    components: {
        SubmitFormButton,
        FormLabel,
        FormInput,
        FormError,
    },

    props: {
        students: {
            required: true,
            type: [Object, Array],
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                student_ids: null,
                points: null,
                coins_points: null,
                health_points: null,
                energy_points: null,
                comment: '',
            }),
        };
    },

    computed: {
        selectedStudentsIds: function () {
            return this.selectedStudents.map((s) => s.id);
        },
        selectedStudents: function () {
            if (Array.isArray(this.students)) {
                return this.students;
            }

            if (typeof this.students === 'object') {
                return [this.students];
            }

            return this.students;
        },
    },

    mounted() {
        this.form.student_ids = this.selectedStudentsIds;
    },

    methods: {
        submit() {
            const url = route('gamification.direct_currency_points.store');
            this.form.post(url, {
                onSuccess: () => {
                    this.$emit('close');
                },
                preserveScroll: true,
            });
        },
    },
};
</script>
